import { render, staticRenderFns } from "./ListaResponsavel.vue?vue&type=template&id=5d18afae"
import script from "./ListaResponsavel.vue?vue&type=script&lang=js"
export * from "./ListaResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports